import pino from 'pino'

class BaseLogger {
  constructor() {
    this.levels = {
      trace: 1,
      debug: 2,
      info: 3,
      warn: 4,
      error: 5,
      fatal: 6,
    }
    this.rootLooger = null
    this.currentLogger = null
    this.userId = null
    this.userToken = null
    this.pageUrl = null

    this.init()
  }

  get logger() {
    return this.currentLogger
  }

  init() {
    this.rootLooger = pino({
      level: process.env.PINO_LOG_LEVEL || 'debug',
      customLevels: this.levels,
      useOnlyCustomLevels: true,
      formatters: {
        level: (label) => {
          return { level: label }
        },
      },
    })

    this.updateLoggerSettings()
  }

  updateLoggerSettings() {
    this.currentLogger = this.rootLooger.child({
      ...(this.userId && { userId: this.userId }),
      ...(this.pageUrl && { pageUrl: this.pageUrl }),
      ...(this.userToken && { userToken: this.userToken }),
    })
  }

  setUserId(id) {
    this.userId = id
    this.updateLoggerSettings()
  }

  setUserToken(token) {
    this.userToken = token
    this.updateLoggerSettings()
  }

  setPageUrl(url) {
    this.pageUrl = url
    this.updateLoggerSettings()
  }
}

const baseLogger = new BaseLogger()

export default baseLogger